import { propertyOf } from 'lodash';

export const extractResponseError = response =>
  propertyOf(response)(['response', 'data', 'errors']);
